export default __webpack_public_path__ + "assets/images/avatar.c76bb7.avif";